module.exports = __webpack_public_path__ + "static/media/unauth_image3.86e8d262.jpg";